export const COMPARE_LIMIT = 4

export const COMPARE_PAGE_URL = `${import.meta.env.BASE_URL}/college-compare`
